import { useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import useAuthUser from "hooks/useAuthUser";
import useBreakPoints from "hooks/useBreakPoints";
import { useHideFooter } from "hooks/useHideFooter";
import { Routes } from "../../router/config";

function useController() {
  const { user } = useAuthUser();
  const history = useHistory();
  const match = useRouteMatch();
  const { desktopUp } = useBreakPoints();
  useHideFooter();

  const [senderUser, setSenderUser] = useState<UserPublicData | null>(null);

  const onClickBackButton = () => {
    history.push(Routes.messages);
  };

  return {
    senderUser,
    setSenderUser,
    desktopUp,
    user,
    onClickBackButton,
    match,
    isSelectThread: history.location.pathname !== match.url,
  };
}

export default useController;
